module.exports = __webpack_public_path__ + "img/user-05.5c033dd0.png";